import api from '@/api';
import { proxy } from 'valtio';

import { normalizeData } from './normalize';

const store = proxy({
    isLoading: false,
    isError: false,
    data: [],
});

const fetch = async triplets => {
    return await api.reports.getGeoStratums({ triplets });
};

const startRequest = () => {
    store.isError = false;
    store.isLoading = true;
};

const setResponse = data => {
    store.isLoading = false;
    store.data = normalizeData(data);
};

const setError = () => {
    store.isError = true;
};

const getGeoStratums = async triplets => {
    startRequest();

    try {
        const response = await fetch(triplets);
        setResponse(response);
    } catch (error) {
        setError();
    }
};

const handleMoveUp = key => {
    const i = store.data.findIndex(e => e.key == key);
    store.data = swapInArray(store.data, i, i - 1);
};

const handleMoveDown = key => {
    const i = store.data.findIndex(e => e.key == key);
    store.data = swapInArray(store.data, i, i + 1);
};

function swapInArray(arr, x, y) {
    const temp = arr[x];

    arr[x] = arr[y];
    arr[y] = temp;

    return arr;
}

export const sampling = {
    store,
    getGeoStratums,
    handleMoveUp,
    handleMoveDown,
};
